import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  SiPostman,
  SiJenkins,
  SiDocker,
  SiPostgresql,
  SiMysql,
} from "react-icons/si";
import { FaAws, FaGoogle, FaMicrosoft } from "react-icons/fa";

function Toolstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons">
        <SiPostgresql />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiMysql />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiJenkins />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiDocker />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiPostman />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <FaAws />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <FaGoogle />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <FaMicrosoft />
      </Col>
    </Row>
  );
}

export default Toolstack;
